import React from "react";

const ProfileContext = React.createContext({
  user: undefined,
  currentPlan: undefined,
  setUser: () => {},
  isOwner: false,
  follow: () => {},
  unfollow: () => {},
  isSubscribed: false,
  viewMode: undefined,
  isCompany: false,
  company: undefined,
  onEdit: () => {},
  onNewProject: () => {},
  isOwnerCompany: false,
  tabs: 0,
  setTabSelected: () => {},
});

export default ProfileContext;
